
export const clearFilterData = {
  SpNm: null,
  SpCd: null,
  SpTypId: null,
  IsActv: null,
}

export const initFilterData = {
  ...clearFilterData,
  IsActv: 1,
}

export const initSparePartTypeDialogData = {
  IsActv: 1,
  SpTypNm: "",
  SpTypSNm: "",
  Dscp: "",
}

export const sparePartTypeColNm = {
  SpTypNm: "ชื่อประเภท",
  SpTypSNm: "ชื่อย่อ",
  Dscp: "รายละเอียด",
  IsActv: "สถานะ",
}

export const initSparePartDialogData = {
  IsActv: 1,
  SpTypId: null,
  SpCd: "",
  SpNm: "",
  SpSNm: "",
  Brand: "",
  Model: "",
  Unt: "",
  UntPr: 0,
  MinStk: 0,
  CurStk: 0,
  Dscp: "",
  Rmk: "",
}
